import script from "./NewslelletrsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewslelletrsView.vue?vue&type=script&setup=true&lang=js"

import "./NewslelletrsView.vue?vue&type=style&index=0&id=2d4a4e43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4a4e43"]])

export default __exports__